import { IActionHandlerParams } from "../types";

export const redirect = (expression: string, parameters: IActionHandlerParams) => {
  parameters.route!.history.push("/" + expression);
};
